module.exports = "/images/icon_logout.png?52abb719a25af5f0bdd47a80db03847b";